import { IsEnum } from 'class-validator';
import { BitcoinNetworkEnvironment } from 'src/v2/bitcoin/types';
import { WalletNetwork } from '@moonpay/login-common';

export class BitcoinSwitchNetworkRequest {
  @IsEnum(BitcoinNetworkEnvironment)
  public readonly networkEnvironment!: BitcoinNetworkEnvironment;
}
